export default {
  isLoaded: false,
  notifications: [],
  allnotifications: [],
  newNotifications: [],
  notificationCount: {},
  announcements: [],
  unreadAnnouncementsCount: null,
  unreadNotifiationCount: null,
}
